import { InternalBank } from "modules/financial";

const InternalBankPage = () => {
  return <InternalBank />;
};

export default InternalBankPage;
